//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { MediaLibrarySourcesDropdownItemData } from '@media-library/components/top-bar/sources-dropdown/mediaLibrarySourcesDropdownConstants';
import {
  hasSelectedDescendant,
  shouldBeSelected,
} from '@media-library/components/top-bar/sources-dropdown/mediaLibrarySourcesDropdownUtils';
import { isDefined } from '@utils/filterPredicates';

export const handleChangeSelectParent = (
  currentSource: MediaLibrarySourcesDropdownItemData,
  targetSource: MediaLibrarySourcesDropdownItemData,
): MediaLibrarySourcesDropdownItemData => {
  if (
    currentSource.paramKey === targetSource.paramKey &&
    currentSource.value === targetSource.value
  ) {
    return {
      ...currentSource,
      isIndeterminate: targetSource.isIndeterminate,
      isSelected: targetSource.isSelected,
      subItems: targetSource.subItems ?? [],
    };
  }

  if (isDefined(currentSource.subItems)) {
    const updatedSubItems = currentSource.subItems.map((subItem) =>
      handleChangeSelectParent(subItem, targetSource),
    );

    const hasUpdatedChild = updatedSubItems.some(
      (updatedItem, index) => updatedItem !== currentSource.subItems?.[index],
    );

    if (hasUpdatedChild) {
      return {
        ...currentSource,
        isIndeterminate: hasSelectedDescendant(updatedSubItems),
        isSelected: shouldBeSelected({
          ...currentSource,
          subItems: updatedSubItems,
        }),
        subItems: updatedSubItems,
      };
    }
  }

  return currentSource;
};
